/**
 * 決算統計目的・性質のCascaderオプション構築
 *
 * 階層: level1→level2→level3→level4
 */

import type { CascaderOption } from '@/shared/ui';
import type { ConvertResultSettlementOption } from '../api/generated/model';
import {
  buildHierarchicalCascaderOptions,
  codeNameLevel,
} from './buildHierarchicalCascaderOptions';

/**
 * 決算統計目的・性質のフラットデータからCascaderオプションを構築
 */
export const buildSettlementCascaderOptions = ({
  settlements,
}: {
  settlements: ConvertResultSettlementOption[] | null | undefined;
}): CascaderOption[] =>
  buildHierarchicalCascaderOptions({
    items: settlements,
    levels: [
      codeNameLevel<ConvertResultSettlementOption>({
        getCode: (s) => s.level1_code,
        getName: (s) => s.level1_name,
      }),
      codeNameLevel<ConvertResultSettlementOption>({
        getCode: (s) => s.level2_code,
        getName: (s) => s.level2_name,
      }),
      codeNameLevel<ConvertResultSettlementOption>({
        getCode: (s) => s.level3_code,
        getName: (s) => s.level3_name,
      }),
      codeNameLevel<ConvertResultSettlementOption>({
        getCode: (s) => s.level4_code,
        getName: (s) => s.level4_name,
      }),
    ],
  });
